module.exports = __webpack_public_path__ + "assets/images/skincolor-04.e34b5542081edd753025e98772241037.svg";